import React from 'react'
import Accordion from './Accordion'

const FaqSection = ({ content }) => {
  const { title, columns = [] } = content || {}

  return (
    <div className='mx-auto pt-40 mb-20 px-4 md:px-8 section-six'>
      <div data-aos="fade-up" className="heading-four text-left md:text-center">
        {title}
      </div>

      <div className="md:flex gap-8 mt-12 md:mt-20">
        {columns.map((items, columnIndex) => (
          <div key={columnIndex} data-aos="fade-up" className='md:w-2/4'>
            {items.map((item, itemIndex) => (
              <Accordion
                key={`${columnIndex}-${itemIndex}`}
                title={item.title}
                desc={item.desc}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FaqSection
